import React from 'react';
import { bool } from 'prop-types';

import MainSlat from './MainSlat';
import NoteSlat from './NoteSlat';


const AnnotationViews = ({ isMain }) => {
  if (isMain) {
    return <MainSlat />;
  }

  return <NoteSlat />;
};

AnnotationViews.propTypes = {
  isMain: bool
};


export default AnnotationViews;
